var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42 12.5L.5 6.42 6.58.5M13.407 12.5l-5.92-6.08L13.566.5",
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgChevronLeftDouble;